import { useMemo } from "react";
import { Item } from "../../types/item";
import { useApp, useAuth, useMenu } from "../../hooks";
import { useMenuStore } from "../../stores";
import APIs from "../../apis";

const useViewModel = () => {
  const categories = useMenuStore((state) => state.categories);
  const menu = useMemo(() => categories ?? [], [categories]);
  const { search: getSearchResults } = useMenu();
  const loading = useMenuStore((state) => state.loading);
  const { refreshUser, user } = useAuth();
  const {
    banners,
    message,
    bootstrap,
    location,
    deliveryTime,
    minimumOrder,
  } = useApp();

  const markFavorite = async (item: Item, isFav: boolean) => {
    try {
      await APIs.auth.modifyFavorite(item.uuid);
      await refreshUser();
      message.success(
        isFav
          ? `${item.name} added to favorites`
          : `${item.name} removed from favorites`,
      );
    } catch (error: any) {
      let errorMsg = "Something went wrong";
      if (error.response?.status === 401)
        errorMsg = "Please login to add favorites";
      message.error(errorMsg);
    }
  };

  return {
    menu,
    loading,
    banners,
    hero: bootstrap?.hero,
    deliveryTime,
    minimumOrder,
    location,
    favorites: user?.favorites ?? [],
    getSearchResults,
    markFavorite,
  };
};

export default useViewModel;
